import { toValue, watch, type MaybeRefOrGetter } from 'vue';

import { pushNotificationsService } from '@/shared/lib';

const initPushNotifications = (userId: MaybeRefOrGetter<string | null | undefined>): void => {
  watch(
    () => toValue(userId),
    (currentUserId: string | null | undefined) => {
      if (currentUserId === undefined) {
        return;
      }

      void pushNotificationsService.sync(currentUserId);
    },
    { immediate: true },
  );
};

export { initPushNotifications };
